import { createIcon } from '@chakra-ui/react';

export const MbeAlert = createIcon({
  displayName: 'MbeAlert',
  viewBox: '0 0 64 65',
  path: (
    <g fill="none" fillRule="evenodd">
      <path
        d="M32.64966970778482,62.84389543930554 c-17.567299797148387,0 -31.857976268257975,-13.819699324928548 -31.857976268257975,-30.799774929793838 c0,-16.98378061808913 14.294508779093258,-30.799774929793838 31.857976268257975,-30.799774929793838 c17.567299797148387,0 31.857976268257975,13.819699324928548 31.857976268257975,30.799774929793838 s-14.294508779093258,30.799774929793838 -31.857976268257975,30.799774929793838 "
        fill="red"
        id="svg_2"
      />
      <path
        d="M32.64966970778482,43.56300662243473 a2.40668941374546,2.3267483045724204 0 1 0 0.0038323079836711203,4.649791595920999 a2.40668941374546,2.3267483045724204 0 0 0 -0.0038323079836711203,-4.649791595920999 m0,6.806109292196714 a4.64092496822572,4.4867710140719765 0 0 1 0,-8.966132001696268 c2.556149425108634,0 4.637092660242049,2.0118221805458987 4.637092660242049,4.483066000848134 c0,2.4712438203022367 -2.0809432351334154,4.483066000848134 -4.637092660242049,4.483066000848134 M32.64966970778482,38.60199391571105 a1.1152016232482944,1.0781588481378572 0 0 1 -1.1152016232482944,-1.0781588481378572 V14.80098896575368 a1.1152016232482944,1.0781588481378572 0 0 1 2.23423555448026,0 v22.72284610181951 c0,0.5965071290384711 -0.5020323458609153,1.0781588481378572 -1.1190339312319655,1.0781588481378572 "
        fill="#FFF"
        id="svg_3"
      />
    </g>
  ),
});
